import { pdf } from '@react-pdf/renderer'
import { Button } from 'components/Form'
import TemplateQr, { registerFonts } from 'components/PosterQR'
import * as React from 'react'
import ModalWrapper from './ModalWrapper'
import './styles.scss'
import { generateQR } from 'utils/helpers'
import { I18n } from 'react-redux-i18n'
import { chatmailProviders } from 'constants/channels'
import Nixi1Spinner from 'components/Nixi1Spinner'

const ModalPosterQR = (props) => {
  const { channels = [], configPoster, isDisplay } = props
  const [fileToDownload, setFileToDownload] = React.useState(null)
  const [isQR, setIsQR] = React.useState(null)
  const [backdrop, setBackdrop] = React.useState(true)
  const [fileDownload, setFileDownload] = React.useState(null)
  React.useEffect(() => {
    registerFonts()
    setIsQR(null)
  }, [])

  React.useEffect(() => {
    if (!isQR) {
      if (!isDisplay) setFileDownload(isDisplay)
      if (isDisplay) {
        setFileDownload(null)
        setFileToDownload(null)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisplay])

  React.useEffect(() => {
    if (channels.length > 0 && !isQR) {
      getQR()
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channels])

  const getQR = async () => {
    setBackdrop('static')

    setTimeout(async () => {
      const dataChannels = await Promise.all(channels.map(async (it, idx) => {
        const link = it.url
        const qr = await generateQR(link)
        it['qr'] = qr
        it['key'] = chatmailProviders.includes(it.key) ? 'chatmail' : it.key
        return it
      }))
      let blob = pdf(<TemplateQr channels={dataChannels} configPoster={configPoster} />).toBlob()
      blob = await blob

      const blobUrl = URL.createObjectURL(blob)
      if (isDisplay) {
        setIsQR(null)
        setFileToDownload(blobUrl)
      }
      else setFileDownload(true)
      setBackdrop(true)
      if (!isDisplay) {
        setIsQR(null)
        setTimeout(async () => {
          await downloadQRAutomatic(blobUrl)
        }, 1000)
      }
    }, 1000)
    setIsQR(null)
  }

  const downloadQRAutomatic = async (file) => {
    const a = document.createElement('a')
    a.href = file
    a.download = 'poster-qr.pdf'
    setIsQR(null)
    a.click()
  }

  const downloadQR = async () => {
    const a = document.createElement('a')
    a.href = fileToDownload
    a.download = 'poster-qr.pdf'
    setIsQR(null)
    a.click()
  }

  const body = () => {
    return (
      <div className={'wrapper-qr'}>
        {fileToDownload ?
          <>
            <span className='preview-text'>{I18n.t('dashboard_preview')}</span>
            <div className='preview-qr'>
              <object
                width='215'
                height='303'
                data={fileToDownload + '#toolbar=0'}
              >
                <p>Your web browser does not have a PDF plugin.</p>
              </object>
            </div>
            <Button className='download-poster' value={I18n.t('channels_qr_button_download')} secondary onClick={downloadQR} />
          </>
          :
          <div className='generating-qr'>
            <span>{I18n.t('channels_qr_loading_message_1')}</span>
            <span>{I18n.t('channels_qr_loading_message_2')}</span>
            <span>{I18n.t('channels_qr_loading_message_3')}</span>
            <div className='spinners'>
              <Nixi1Spinner height='25px' width='25px'/>
              <Nixi1Spinner height='25px' width='25px'/>
              <Nixi1Spinner height='25px' width='25px'/>
            </div>
          </div>
        }
      </div>
    )
  }

  const bodyDownload = () => {
    return (
      <div className={'wrapper-qr'}>
        {!fileDownload ?
          <div className='generating-qr'>
            <span>{I18n.t('channels_qr_loading_message_1')}</span>
            <span>{I18n.t('channels_qr_loading_message_2')}</span>
            <div className='spinners'>
              <Nixi1Spinner height='25px' width='25px'/>
              <Nixi1Spinner height='25px' width='25px'/>
              <Nixi1Spinner height='25px' width='25px'/>
            </div>
          </div>
          : null
        }
      </div>
    )
  }

  return (
    <ModalWrapper
      id={'modalPosterQR'}
      header={<h1>{I18n.t('channels_qr_title')}</h1>}
      body={
        isDisplay ? body() : bodyDownload()
      }
      isOpen={isDisplay ? props.isOpen : props.isOpen && !fileDownload}
      toggle={props.toggle}
      showClose={true}
      backdrop={backdrop}
    />
  )
}

export default ModalPosterQR